import React from 'react';
import wkx from 'wkx';
import L from 'leaflet';
import buffer from 'buffer';
import PigeonMap from 'pigeon-maps'
import Delegate from './Delegate';
import {track} from './tracking';

const MIN_ZOOM = 14;
const MAX_ZOOM = 18;

class HomeMarker extends React.Component {
  render () {
    const { left, top, onClick } = this.props

    const style = {
      position: 'absolute',
      transform: `translate(${left - 40}px, ${top - 50}px)`,
      cursor: onClick ? 'pointer' : 'default'
    }

    return (
      <div style={style}>
        <div className="standard standardMarker">
          <img src={require('./img/home_marker.svg')} width="80px" />
        </div>
      </div>
    )
  }
}

class Marker extends React.Component {
  eventParameters = (event) => ({
    event,
    anchor: this.props.anchor,
    payload: this.props.payload
  })

  handleClick = (event) => {
    this.props.onClick && this.props.onClick(this.eventParameters(event))
  }

  render () {
    const { left, top, onClick } = this.props

    const style = {
      position: 'absolute',
      transform: `translate(${left - 25}px, ${top - 36}px)`,
      cursor: onClick ? 'pointer' : 'default'
    }

    return (
      <div style={style}
           onClick={this.handleClick}
      >
        <div id={`marker-${this.props.id}`} className="marker standard standardMarker">
          <svg width="50px" height="72px">
            <path fill="#008FED" d="M49.021,24.708c0,13.333-24.669,47.525-24.669,47.525S0.742,38.04,0.742,24.708s10.808-24.14,24.14-24.14 C38.215,0.568,49.021,11.375,49.021,24.708z" />
          </svg>
          <span>{ this.props.value }</span>
        </div>
      </div>
    )
  }
}

const ACCESS_TOKEN = 'pk.eyJ1Ijoiam9jYW1sIiwiYSI6Ijg2ZGZjNTY2MWQ3NjdlZmU3ODhiNzk1MTkwZDg2ZTQ2In0.DYFWbv_uv3DjGeKhmhfCng';

function provider(x, y, z, dpr) {
  return `/map_proxy/${x}/${y}/${z}/`;
  if (!!window.location.host.match(/intra/)) {
    return `https://maps.intra.go2digital.hr/styles/klokantech-basic/${z}/${x}/${y}.png`;
  } else {
    return `https://maps.go2digital.hr/styles/klokantech-basic/${z}/${x}/${y}.png`;
  }
}

export default function Map(props) {
  const isFull = props.category == null || props.lang == null;
  return (
    <div className="pigeon-map" style={{width: '100%', height: '100%', overflow: 'hidden'}}>
      <PigeonMap
        width={isFull ? 1920 : 940}
        height={isFull ? 1920 : 940}
        center={props.center}
        zoom={props.zoom}
        onBoundsChanged={props.updateMap}
        minZoom={MIN_ZOOM}
        maxZoom={MAX_ZOOM}
        provider={provider}
      >
        <HomeMarker anchor={[props.homeLocation[1], props.homeLocation[0]]} />
        { props.poi.map((poi, i) => (
            <Marker
              key={poi.poi_id}
              anchor={poi.location}
              value={i+1}
              payload={poi}
              onClick={({ event, anchor, payload }) => props.onSelect(payload)} />
          ))
        }
      </PigeonMap>
    </div>
  );
}

export class MapControls extends React.Component {

  render () {
    return (
      <div className="MapControls">
        <div>
          <div className="zoomOut" onClick={() => this.changeZoom(-1)} />
          <div className="zoomIn" onClick={() => this.changeZoom(1)} />
        </div>
      </div>
    );
  }

  changeZoom (by) {
    const { map: { zoom }, updateMap } = this.props;
    if (zoom + by > MAX_ZOOM || zoom + by < MIN_ZOOM) return;
    updateMap({zoom: zoom + by})
  }
}


// TODO What was this?
class SubcatMarker extends React.Component {
  render () {
    return (
      <div className="subcat">
        <svg width="50px" height="50px">
          <path fill="#FFFFFF" d="M43.583,0.487H6.419c-2.006,0-3.632,1.626-3.632,3.632v34.02c0,2.006,1.626,3.631,3.632,3.631h14.017 l4.47,7.742l4.468-7.742h14.209c2.005,0,3.63-1.625,3.63-3.631V4.12C47.213,2.114,45.588,0.487,43.583,0.487z"/>
        </svg>
        <img src={this.props.src} alt="" />
      </div>
    );
  }
}

